import { render, staticRenderFns } from "./NewEditSegmentPage.vue?vue&type=template&id=19a63a96&scoped=true&"
import script from "./NewEditSegmentPage.vue?vue&type=script&lang=js&"
export * from "./NewEditSegmentPage.vue?vue&type=script&lang=js&"
import style0 from "./NewEditSegmentPage.vue?vue&type=style&index=0&id=19a63a96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a63a96",
  null
  
)

export default component.exports